<template>
	<div class="guanhuaibox">
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/yhgh.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/yhgh1.png" class="steps step2" v-if="status==2">
			<img src="../../assets/images/yhgh3.png" class="steps step3" v-if="status==3">
			<img src="../../assets/images/yhgh4.png" class="steps step4" v-if="status==4">
			<img src="../../assets/images/yhgh2.png" class="steps step5" v-if="status==5">
			<img src="../../assets/images/yhgh5.png" class="steps step6" v-if="status==6">
			<img src="../../assets/images/yhgh6.png" class="steps step7" v-if="status==7">
			<img src="../../assets/images/yhgh9.png" class="steps step8" v-if="status==8">
			<img src="../../assets/images/yhgh8.png" class="steps step9" v-if="status==9">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"下一步":status==4?"下一步":status==5?"下一步":status==6?"下一步":status==7?"下一步":status==8?"下一步":status==9?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
		<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'}]" />
		<div class="h-content">
			<div class="h-optionItem">
				<div class="h-optionItemin">
					<ul>
						<li v-auth="'meiriplan'">
							<router-link :to="{path:'/shijipaodong', query: {}}">
								<div class="h-oItemIntro h-disTable h-oItem-icon1">
									<div class="h-tableCell">
										<p>每日计划</p>
										<span><span class="h-oItemIntroTitle">计划总数</span><span class="h-oItemIntroNum">{{headnum.headnum}}</span></span>
									</div>
								</div>
							</router-link>
						</li>
						<li v-auth="'shijirun'">
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon7" @click="gundong">
									<div class="h-tableCell">
										<p>实际跑动</p>
										<span><span class="h-oItemIntroTitle">已完成</span><span class="h-oItemIntroNum">{{headnum.headdone}}</span></span>
									</div>
								</div>
							</a>
						</li>
						<li v-auth="'paodongwhl'">
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon2">
									<div class="h-tableCell">
										<p>跑动吻合率</p>
										<span><span class="h-oItemIntroTitle h-greenFont">{{headnum.headmatch}}%</span></span>
									</div>
								</div>
							</a>
						</li>
						<li v-auth="'whllist'">
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon00" @click="pdwhllist">
									<div class="h-tableCell">
										<p>跑动吻合率</p>
									</div>
								</div>
							</a>
						</li>
						<li v-auth="'zonghegrade'">
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon8">
									<div class="h-tableCell">
										<p>综合评分</p>
										<span><span class="h-oItemIntroTitle h-greenFont">{{headnum.grade}}</span></span>
									</div>
								</div>
							</a>
						</li>
						<li v-auth="'zongherank'">
							<router-link :to="{path:'/paiming'}">
								<div class="h-oItemIntro h-disTable h-oItem-icon01">
									<div class="h-tableCell">
										<p>综合排名</p>
									</div>
								</div>
							</router-link>
						</li>
						<li v-if="headnum.rqId" v-auth="'myriqi'">
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon9">
									<div class="h-tableCell">
										<p>我的日清</p>
										<span><span class="h-oItemIntroTitle">已提报</span></span>
									</div>
								</div>
							</a>
						</li>
						<li v-if="!headnum.rqId" v-auth="'myriqi'">
							<router-link :to="{path:'/presentation'}">
								<div class="h-oItemIntro h-disTable h-oItem-icon9">
									<div class="h-tableCell">
										<p>我的日清</p>
										<span><span class="h-oItemIntroTitle">日清提报</span></span>
									</div>
								</div>
							</router-link>
						</li>
						<li v-auth="'recordweihu'">
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon10" @click="uploaddownexcelflagbtn">
									<div class="h-tableCell">
										<p>记录维护</p>
										<span><span class="h-oItemIntroTitle">批量导入</span></span>
									</div>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn" style="width: 60%;">
					<div class="h-rowBox" style="height:8.35rem">
						<div class="h-rowTitle">
							<div class="h-disTable" style="display: flex;align-items: center;">
								<div class="h-tableCell" style="display: flex;align-items: center;">
									<h1>我的日程</h1>
									<div class="h-calendarSelect">
										<div class="h-csBox">
											<el-select v-model="yearValue" placeholder="请选择" @change="handleYearClick">
												<el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue" placeholder="请选择" @change="handleMonthClick">
												<el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
									<div class="h-calenderSign">
										<span><i class="h-redBg"></i>已过期</span>
										<span><i class="h-blueBg"></i>当前</span>
										<span><i class="h-greenBg"></i>提醒</span>
									</div>
									<!-- <el-button v-auth="'cjweekplan'" class="h-btn h-formBtn h-bgblueQ" @click="addweek" style="margin-left:30px;font-size: 0.16rem;padding: 0.12rem 0.2rem;">创建周计划</el-button> -->
								</div>
							</div>
						</div>
						<div class="h-rowCon ljjcalendar" style="position:relative">
							<el-calendar v-model="calenderValue" style="overflow:hidden;">
								<template slot="dateCell" slot-scope="{date, data}">
									<div class="h-day" @click="handleDateClick(date)">
										<div style="height:0.99rem;;overflow:hidden;">
											<span class="h-dayNum">
												{{data.day.split('-')[2].replace(/^0+/,'')}}
												<div v-for="(item,index) in calenderData" :key="index">
													<i class='h-daySign h-greenBg' v-if="item.planTimeEnd.split(' ')[0]>$util.riQi3(tdate)&&data.day==item.planTimeEnd.split(' ')[0]"></i>
													<i class='h-daySign h-redBg' v-if="$util.riQi3(tdate)>item.planTimeEnd.split(' ')[0]&&data.day==item.planTimeEnd.split(' ')[0]"></i>
													<i class='h-daySign h-blueBg' v-if="$util.riQi3(tdate)==item.planTimeEnd.split(' ')[0]&&data.day==item.planTimeEnd.split(' ')[0]"></i>
												</div>
											</span>
											<div style="padding-top:0.48rem;height:0.99rem;overflow:hidden;" @click="selecttime(data.day)">
												<div v-for="(item,index) in calenderData" :key="index" class="calenderdata">
													<div class="h-dataInfo" v-if="
																data.day.split('-')[2].replace(/^0+/,'')==item.planTimeEnd.split(' ')[0].split('-')[2].replace(/^0+/,'')
																&& data.day.split('-')[1].replace(/^0+/,'')==item.planTimeEnd.split(' ')[0].split('-')[1].replace(/^0+/,'')">
														<p>{{item.planTimeStart.split(' ')[1].substr(0,5)}}~{{item.planTimeEnd.split(' ')[1].substr(0,5)}}
														</p>
														<p>{{item.euName}} {{item.planRemark}}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</el-calendar>
							<div class="planBoxzhezhao" v-if="planBoxlist">
								<div class="planBoxs">
									<div class="planBoxtop">{{detailDayString}}</div>
									<div class="planBoxcenter">
										<div class="planBoxcenterlist" v-for="(item,index) in planlists" :key="index">
											<div class="divs">
												<div v-if="item.active!=0" class="nullwan">未完成</div>
												<div v-if="item.active==0" class="nullwan" style="border: solid 1px #4caf50;background:0;color: #65ba69;">已完成</div>
											</div>
											<div class="divs">
												<div class="centertext" :title="item.euName?item.euName:''">{{item.euName?item.euName:''}}</div>
											</div>
											<div class="divs">
												<div class="baifantext" :title="item.contact">{{item.contact}}</div>
											</div>
											<div class="divs">
												<!-- <div class="timetext" :title="item.planTimeStart.substr(0,16)+'--'+item.planTimeEnd.substr(0,16)" v-if="item.planTimeEnd.split(' ')[0]!=item.planTimeStart.split(' ')[0]"> {{item.planTimeStart.substr(0,16)}}--{{item.planTimeEnd.substr(0,16)}}</div>
                                                <div class="timetext" :title="item.planTimeEnd.split(' ')[1].substr(0,5)+'--'+item.planTimeEnd.split(' ')[1].substr(0,5)" v-if="item.planTimeEnd.split(' ')[0]==item.planTimeStart.split(' ')[0]"> {{item.planTimeEnd.split(' ')[1].substr(0,5)}}--{{item.planTimeEnd.split(' ')[1].substr(0,5)}}</div> -->
											</div>
											<div class="divs">
												<div v-if="item.active==1" class="editortext" @click="editorplan(item.id)">修改计划</div>
												<div v-if="item.active==2&&item.planStatus!=4&&item.planStatus!=5" class="editortext" @click="tibaobut(item.id)"
												 style="background:#ee9433;">提报原因</div>
												<div v-if="item.active==9">{{item.cuname}}</div>
											</div>
											<div class="divs">
												<div class="chakan" @click="checkDetail(item.id)">查看</div>
											</div>
										</div>
									</div>
									<div class="backtext" @click="planBoxlist=false">返回</div>
									<div class="planBoxbottom">
										<div></div>
										<div class="h-pagination fenyes">
											<paginationmincopy :page="q1" @query="selecttimeQ(detailDayString)" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="h-rowIn" style="width: 40%;">
					<div class="h-rowBox" style="height: 4.1rem;">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>绩效排名</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="blankimg" v-if="blank1_1&&blank1_2" style="text-align: center;">
								<img src="../../assets/images/mylittle.png" style="width: 70%;">
							</div>
							<div style="display:flex;" v-show="!blank1_1||!blank1_2">
								<div class="h-pieChart" id="h_barChart" style="width: 70%; height: 2.5rem;flex-shrink:0"></div>
								<div style="display:flex;flex-direction: column;width: 30%;">
									<div class="selecBox" style="margin-top:20px;">
										<div class="button" :class="{'active':paidex==index}" v-for="(item,index) in paiminglist" :key="index" @click="tab2(index)">{{item}}</div>
									</div>
									<div v-if="paidex==0" class="paimingBox">
										<div class="title">当天绩效排名<span style="margin-left:10px;font-weight:bold">{{jxDayRank}}</span></div>
										<div class="borderBox">
											<div class="borders" :style="{width:jxDayWidth}"></div>
										</div>
									</div>
									<div v-if="paidex==1" class="paimingBox">
										<div class="title">当月绩效排名<span style="margin-left:10px;font-weight:bold">{{jxMonthRank}}</span></div>
										<div class="borderBox">
											<div class="borders" :style="{width:jxMonthWidth}"></div>
										</div>
									</div>
								</div>
							</div>
							<div class="textBox" v-show="!blank1_1||!blank1_2">
								<span>当天排名<span style="color:#8b8b8b;margin-left:5%;">{{jxDayRank}}</span></span>
								<span>当月排名<span style="color:#8b8b8b;margin-left:5%;">{{jxMonthRank}}</span></span>
								<!-- <span style="color:#bae5c0;margin-left:10%;">+16.1%</span> -->
							</div>
						</div>
					</div>
					<div class="h-rowBox" style="margin-top: 0.26rem;height: 4rem;">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>跑动排名</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="blankimg" v-if="blank2" style="text-align: center;">
								<img src="../../assets/images/mylittle.png" style="width: 70%;">
							</div>
							<div style="display:flex;" v-show="!blank2">
								<div class="h-pieChart" id="h_lineChart" style="width: 85%; height: 2.5rem;"></div>
								<div style="display:flex;flex-direction: column;width: 15%;">
									<div style="margin-top:30px;color:#525962;font-size:22px;">{{care}}</div>
									<div style="margin-top:10px;font-size:18px;color:#d1d8db">总排名</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="h-piece h-mrt30">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="区域">
								<brselect v-model="q.areaCode" :v="q.areaCode" category="YLRegion" :clearable="true"></brselect>
							</el-form-item>
							<el-form-item label="客户名称">
								<el-input v-model="q.euNameLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="拜访日期" class="timeselect" style="width: 50%;">
								<el-date-picker
									v-model="q.cdateBegin"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="q.cdateEnd"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="提报人">
										<el-input v-model="q.cuname" placeholder="请输入"></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
						<!-- <el-form-item class="h-formBtnOut">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn" @click="reset" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
						</el-form-item>
						<el-form-item class="h-formBtnOut">
							<div class="h-listTab">
								<a :class="['h-ltTableIcon',{'h-active':clickActive==1}]" @click="handleTabClick(1)"></a>
								<a :class="['h-ltListIcon',{'h-active':clickActive==2}]" @click="handleTabClick(2)"></a>
							</div>
						</el-form-item> -->
					</el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置
							</el-button>
							<div class="h-listTab">
								<a :class="['h-ltTableIcon',{'h-active':clickActive==1}]" @click="handleTabClick(1)"></a>
								<a :class="['h-ltListIcon',{'h-active':clickActive==2}]" @click="handleTabClick(2)"></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-table h-mrt30" v-if="clickActive==1">
				<el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="tableData2" @header-click="headerClick" :border="true"
				 stripe style="width: 100%" max-height="440">
					<el-table-column type="selection" width="45" label="全选">
					</el-table-column>
					<el-table-column fixed type="index" label="#" width="40">
					</el-table-column>
					<el-table-column prop="areaCode" label="区域" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{scope.row.areaCode | dictname('YLRegion')}}
						</template>
					</el-table-column>
					<el-table-column prop="ghRole" label="角色" width="90" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="cuname" label="提报人" width="80" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="euName" label="客户名称" min-width="180" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.euName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="planRemark" label="拜访内容" :show-overflow-tooltip="true" width="180">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.planRemark}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="result" label="拜访结果" :show-overflow-tooltip="true" min-width="180">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.result}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="careTime" sortable label="拜访日期" width="110">
					</el-table-column>
					<el-table-column prop="contact" label="联系人" width="80" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="contactDept" label="部门/科室" width="100" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="contactPhone" label="联系电话" width="120" :show-overflow-tooltip="true">
						<template scope="scope">
						    <div style="text-align: left;">
								{{scope.row.contactPhone}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="exeAgentName" label="跑动经销商" width="180" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.exeAgentName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="prodseries" label="产品大类" width="100" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="promodel" label="产品型号" width="160" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.promodel}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="proPrice" label="单价" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.proPrice}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="proNumber" label="数量" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.proNumber}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="proTotalAmount" label="合计" width="80" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.proTotalAmount}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="160" fixed="right">
						<template slot-scope="scope">
							<div style="text-align: left;">
								<el-button type="text" size="small" class="h-tableLink h-btn" @click="saveJingPin(scope.row.id)" v-if="scope.row.cucode == nowcucode">
									竞品维护
								</el-button>
								<el-button type="text" size="small" class="h-tableLink h-btn" @click="checkDetail2(scope.row.id)">
									查看
								</el-button>
							</div>
							
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-jpwh" v-if="scope.row.cucode == nowcucode" title="竞品维护" @click="saveJingPin(scope.row.id)"></span>
								<span class="l-operationlist br-operation-look" title="查看" @click="checkDetail2(scope.row.id)"></span>
							</div> -->
						</template>
					</el-table-column>
				</el-table>
				<div class="h-tableB h-mrt30">
					<div class="h-tableBL" v-auth="'pljhan'">
						<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="daochu" @click="exportExcel">批量导出</el-button>
						<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>
						<uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="ghexecutionImportExcel"
						 :startrow="3" @callback="uploadExcelFilecallback" />
						<el-button class="h-btn h-formBtn h-bgblueQ" @click="deleteExe">批量删除</el-button>
					</div>
					<div class="h-pagination2">
						<paginationmincopy :page="q" @query="query" />
					</div>
				</div>
			</div>
			<div v-if="clickActive==2">
				<div class="h-piece h-mrt30">
					<div class="h-tableList">
						<div class="h-tableListin">
							<ul>
								<li v-for="(item,index) in tableData2" :key="index">
									<div class="h-tableListItem">
										<div class="h-tListItemT" style="margin-bottom: 0.2rem">
											<div class="h-tListItemTopL">
												<p>{{item.cdate.split(" ")[0]}}</p>
												<span>{{item.cdate.split(" ")[1]}}</span>
											</div>
											<div class="h-tListItenTopR" style="margin-top:-10px;">
												<span>提报人：</span>
												<span>{{item.cuname}}</span>
											</div>
										</div>
										<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
											<p class="h-grayFont">交互图片</p>
											<i v-if="item.saveurl != '1'">
                        <el-image
                            style="width: 3.1rem;height: 2.0rem;"
                            :src="item.saveurl"
                            :preview-src-list="srcList">
                        </el-image>
<!--												<img :src="item.saveurl" style="width: 3.1rem;height: 2.0rem;">-->
											</i>
											<i v-if="item.saveurl == '1'">
												<img src="../../assets/images/mylittle.png"
												 style="width: 3.1rem;height: 2.0rem;"></i>
										</div>
										<p class="h-tListTxt h-mrt20" :title="item.euName" style="width:220px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">客户名称：{{item.euName}}</p>
										<p class="h-tListTxt h-mrt20" :title="item.address" style="width:220px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">拜访地点：{{item.address}}</p>
										<div class="h-txtCenter h-mrt25">
											<el-button class="h-btn h-formBtn h-bgblueQ" @click="checkDetail2(item.id)">查看详情</el-button>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					
				</div>
				<div style="margin-top: 0.3rem;">
					<paginationmincopy :page="q" @query="query" />
				</div>
			</div>
			
		</div>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>新建交互计划</h1>
						<p>New Care Plan</p>
					</div>
				</div>
			</div>
			<div class="h-formLine">
				<el-form :v-model="formLabelAlign2" label-position="right" ref="formLabelAlign2" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item label="拜访客户" class="h-elformWrap-2" style="margin-bottom: 0.2rem;">
						<el-select placeholder="请选择" v-model="formLabelAlign2.name1">
							<el-option label="青岛大学附属医院" value="type1"></el-option>
							<el-option label="类型二" value="type2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="拜访类型" class="h-elformWrap-2">
						<el-select placeholder="请选择" v-model="formLabelAlign2.name2">
							<el-option label="常规拜访" value="type1"></el-option>
							<el-option label="类型二" value="type2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="拜访时间" class="h-elformWrap-1">
						<el-col :span="11">
							<el-date-picker v-model="formLabelAlign2.name3" type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
						</el-col>
						<el-col class="line h-txtCenter" :span="2">至</el-col>
						<el-col :span="11">
							<el-time-picker v-model="formLabelAlign2.name4" type="datetime" placeholder="选择时间" style="width: 100%;"></el-time-picker>
						</el-col>
					</el-form-item>
					<el-form-item label="用户渠道" class="h-elformWrap-2">
						<el-select placeholder="请选择" v-model="formLabelAlign2.name5">
							<el-option label="常规拜访" value="type1"></el-option>
							<el-option label="类型二" value="type2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="区域" class="h-elformWrap-2 h-regionForm">
						<el-col :span="8">
							<el-select placeholder="省" v-model="formLabelAlign2.name6">
								<el-option label="山东省" value="province1"></el-option>
								<el-option label="河北省" value="province2"></el-option>
							</el-select>
						</el-col>
						<el-col :span="8">
							<el-select placeholder="市" v-model="formLabelAlign2.name7">
								<el-option label="青岛市" value="city1"></el-option>
								<el-option label="济南市" value="city2"></el-option>
							</el-select>
						</el-col>
						<el-col class="line h-txtCenter" :span="1"></el-col>
						<el-col :span="8">
							<el-select placeholder="区" v-model="formLabelAlign2.name8">
								<el-option label="青岛市" value="area1"></el-option>
								<el-option label="济南市" value="area2"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
				</el-form>
				<div class="h-formPiece">
					<div v-for="(item,index) in planList" :key="index" class="planList">
						<el-form :v-model="item" label-position="right" ref="formLabelAlign2" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
							<el-form-item label="部门科室" class="h-elformWrap-1">
								<el-input v-model="item.name9"></el-input>
							</el-form-item>
							<el-form-item label="姓名" class="h-elformWrap-2">
								<el-input v-model="item.name10"></el-input>
							</el-form-item>
							<el-form-item label="联系方式" class="h-elformWrap-2">
								<el-input v-model="item.name11"></el-input>
							</el-form-item>
							<el-form-item label="洽谈内容" class="h-elformWrap-1">
								<el-input v-model="item.name12"></el-input>
							</el-form-item>
							<a class="h-addForm" v-if="index<=0" @click="addplanList"><span>+</span></a>
							<a class="h-addForm" v-else @click="delplanList"><span>-</span></a>
						</el-form>
					</div>

				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
				<el-button class="h-btn h-formBtn h-bgblueQ2" @click="dialogFormVisible = false">提交新增计划</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="过期拜访计划原因提报" :visible.sync="dialogFormVisible1" v-if="dialogFormVisible1" class="h-dialog">
			<div class="h-formLine">
				<el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item label="拜访客户" class="h-elformWrap-2">{{formLabelAlign3.euName}}
						<span class="h-readOnlyTxt"></span>
					</el-form-item>
					<el-form-item label="客户类型" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">
							<dictname category="userCareType" :v="formLabelAlign3.euType" /></span>
					</el-form-item>
					<el-form-item label="拜访时间" class="h-elformWrap-1">
						<span class="h-fl">
							<span class="h-readOnlyTxt">{{formLabelAlign3.planTimeStart}}</span>
						</span>
						<el-col class="line h-txtCenter" :span="2">至</el-col>
						<span class="h-fl">
							<span class="h-readOnlyTxt">{{formLabelAlign3.planTimeEnd}}</span>
						</span>
					</el-form-item>
					<el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.areaCode | dictname('YLRegion')}}
					</el-form-item>
					<el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.channelCode | dictname('sales_region')}}
					</el-form-item>
				</el-form>
				<div class="h-formPiece yxgundong">
					<el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"
					 class="demo-ruleForm h-formbLine h-dialogForm">
						<el-form-item label="部门/科室" class="h-elformWrap-1">
							<span class="h-readOnlyTxt">{{formLabelAlign3.contactDept}}</span>
						</el-form-item>
						<el-form-item label="关键人" class="h-elformWrap-1">
							<span class="h-readOnlyTxt">{{formLabelAlign3.contact}}</span>
						</el-form-item>
						<el-form-item label="联系方式" class="h-elformWrap-1">
							<span class="h-readOnlyTxt">{{formLabelAlign3.contactPhone}}</span>
						</el-form-item>
						<el-form-item label="洽谈内容" prop="formCon10" class="h-elformWrap-1">
							<span class="h-readOnlyTxt">{{formLabelAlign3.planRemark}}</span>
						</el-form-item>
					</el-form>
				</div>
				<!-- <div class="h-formRow">
                  <el-form ::model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
                       <el-form-item label="位置信息" class="h-elformWrap-1">
                          <span class="h-readOnlyTxt">
                              <span>{{formLabelAlign3.province}}</span>
                              <span>{{formLabelAlign3.city}}</span>
                              <span>{{formLabelAlign3.county}}</span>
                          </span>
                          <p class="h-readOnlyTxt">
                              {{formLabelAlign3.address}}
                          </p>
                        </el-form-item>
                    </el-form>
                </div> -->
				<div class="h-formReason">
					<el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"
					 class="demo-ruleForm h-formbLine h-dialogForm">
						<el-form-item label="过期原因" class="h-elformWrap-1" prop="explain">
							<el-input type="textarea" v-model="formLabelAlign3.remark" style="height: 27px;"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible1 = false">取 消</el-button>
				<el-button class="h-btn h-formBtn h-bgblueQ2" @click="submitReasonOrChange(1)">提交保存</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="计划修改" :visible.sync="dialogFormVisible2" class="h-dialog">
			<div style="margin-top:10px;font-size:16px;color:#f23522;text-align:center;">温馨提示：修改后本次交互计划将转为未达成状态，请慎重选择。</div>
			<div class="h-formLine">
				<el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item label="客户类型" class="h-elformWrap-1" prop="euType">
						<el-select v-model="formLabelAlign3.euType" placeholder="请选择" @change="customerType">
							<el-option v-for="(item) in options2" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="拜访客户" class="h-elformWrap-1" prop="euCode">
						<el-select v-model="formLabelAlign3.euName" :v="formLabelAlign3.euName" filterable remote placeholder="请输入"
						 :remote-method="showFormList" @change="showForm">
							<el-option v-for="(item) in EuName" :key="item.usercode" :label="item.userName" :value="item.userName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="拜访时间" class="h-elformWrap-1">
						<span class="h-fl">
							<el-date-picker :clearable="false" @change="beginDate(formLabelAlign3)" v-model="formLabelAlign3.planTimeStart"
							 value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
						</span>
						<el-col class="line h-txtCenter" :span="2">至</el-col>
						<span class="h-fl">
							<el-date-picker :clearable="false" @change="processDate(formLabelAlign3)" v-model="formLabelAlign3.planTimeEnd"
							 value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
						</span>
					</el-form-item>
					<!-- <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==1">
                          <brselect category="YLRegion" :v="formLabelAlign3.areaCode" v-model="formLabelAlign3.areaCode"
                              placeholder="--请选择--"></brselect>
                    </el-form-item>
                    <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
                          {{formLabelAlign3.areaCode | dictname('YLRegion')}}
                    </el-form-item>
                    <el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
                          {{formLabelAlign3.channelCode | dictname('sales_region')}}
                    </el-form-item> -->
					<!-- <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType!=1">
                          <el-input v-model="formLabelAlign3.areaName" placeholder="根据客户自动带出" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
                              <el-input v-model="formLabelAlign3.channelCode" placeholder="根据客户自动带出" readonly></el-input>
                    </el-form-item> -->
				</el-form>
				<div class="h-formPiece">
					<el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"
					 class="demo-ruleForm h-formbLine h-dialogForm">
						<el-form-item label="部门/科室" class="h-elformWrap-1">
							<el-input placeholder="根据客户自动带出" v-model="formLabelAlign3.contactDept"></el-input>
						</el-form-item>
						<el-form-item label="关键人" class="h-elformWrap-1">
							<el-input placeholder="根据客户自动带出" v-model="formLabelAlign3.contact"></el-input>

						</el-form-item>
						<el-form-item label="联系方式" class="h-elformWrap-1" prop="contactPhone">
							<el-input placeholder="根据客户自动带出" v-model.number="formLabelAlign3.contactPhone"></el-input>

						</el-form-item>
						<el-form-item label="洽谈内容" prop="planRemark" class="h-elformWrap-1">
							<el-input placeholder="请输入" v-model="formLabelAlign3.planRemark"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible2 = false">取 消</el-button>
				<el-button class="h-btn h-formBtn h-bgblueQ2" @click="submitReasonOrChange(2)">确认修改</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="查看详情" :visible.sync="dialogFormVisible3" class="h-dialog">
			<div class="h-runningDetail" style="border-top:0;padding:0.32rem;padding-left: 0.5rem;">
				<div class="h-rdTitle">
					<h1>{{qdetail.euName}}</h1>
					<label v-if="qdetail.executionId">已拜访</label>
					<label v-if="!qdetail.executionId">未拜访</label>
				</div>
				<div class="h-rdForm">
					<div class="h-rdFormWrap" style="width:100%;height:0.5rem">
						<p class="h-grayFont" style="display:inline-block;margin-right:0.3rem">拜访时间</p>
						<div v-if="qdetail.ex" style="display:inline-block"></div>
						<p v-if="qdetail.planTimeEnd && qdetail.planTimeEnd.split(' ')[0]!=qdetail.planTimeStart.split(' ')[0]" style="display:inline-block">{{qdetail.planTimeStart.substr(0,16)}}
							-- {{qdetail.planTimeEnd.substr(0,16)}}</p>
						<p v-if="qdetail.planTimeEnd && qdetail.planTimeEnd.split(' ')[0]==qdetail.planTimeStart.split(' ')[0]" style="display:inline-block">{{qdetail.planTimeEnd.split(' ')[1].substr(0,5)}}--{{qdetail.planTimeEnd.split(' ')[1].substr(0,5)}}</p>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">负责人</p>
						<p>{{qdetail.contact}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont">部门/科室</p>
						<p>{{qdetail.contactDept}}</p>
					</div>
					<div class="h-rdFormWrap" style="padding-left: 1.2rem;box-sizing:border-box;text-align:center">
						<p class="h-grayFont">拜访对象</p>
						<div v-if="qdetail.euType">
							{{qdetail.euType | dictname('userCareType')}}
						</div>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">联系方式</p>
						<p>{{qdetail.contactPhone}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈内容</p>
						<el-input type="textarea" maxlength="200" :value="qdetail.planRemark?qdetail.planRemark:(qdetail.userCareExecution?qdetail.userCareExecution.planRemark:'')"
						 readonly></el-input>
						<!-- <p>{{qdetail.planRemark?qdetail.planRemark:''}}</p> -->
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈结果</p>
						<p :title="qdetail.userCareExecution?qdetail.userCareExecution.result:''">{{qdetail.userCareExecution?qdetail.userCareExecution.result:''}}</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
						<p class="h-grayFont">交互图片</p>
						<ul>
							<li v-for="(item,index) in PhotoList" :key="index">
                <el-image
                    style="width: 0.6rem;height: 0.6rem;"
                    :src="item.saveurl"
                    :preview-src-list="srcList">
                </el-image>
							</li>
						</ul>
					</div>

				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-bBtn" :class="[qdetail.cucode==nowcucode&&qdetail.userCareExecution&&qdetail.userCareExecution.transform==0?'h-bgwhite':'h-bgblueQ2']" @click="dialogFormVisible3 = false">取消</el-button>
				<el-button v-if="qdetail.cucode==nowcucode&&qdetail.userCareExecution&&qdetail.userCareExecution.transform==0" class="h-btn h-formBtn h-bgblueQ2"
				 @click="zhuanhuaxuqiu">一键转化需求</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="查看详情" :visible.sync="dialogFormVisible6" class="h-dialog">
			<div class="h-runningDetail" style="border-top:0;padding:0.32rem;padding-left: 0.5rem;">
				<div class="h-rdTitle">
					<h1>{{qdetail1.euName}}</h1>
					<label>已拜访</label>
				</div>
				<div class="h-rdForm">
					<div class="h-rdFormWrap" style="width:100%;height:0.5rem">
						<p class="h-grayFont" style="display:inline-block;margin-right:0.3rem">拜访时间</p>
						<p style="display:inline-block">{{qdetail1.cdate}}</p>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">负责人</p>
						<p>{{qdetail1.contact}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont">部门/科室</p>
						<p>{{qdetail1.contactDept}}</p>
					</div>
					<div class="h-rdFormWrap" style="padding-left: 1.2rem;box-sizing:border-box;text-align:center">
						<p class="h-grayFont">拜访对象</p>
						<div v-if="qdetail1.euType">
							<p>
								<dictname category="userCareType" :v="qdetail1.euType" />
							</p>
						</div>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">联系方式</p>
						<p>{{qdetail1.contactPhone}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈内容</p>
						<el-input type="textarea" maxlength="200" :value="qdetail1.planRemark" readonly></el-input>
						<!-- <p>{{qdetail.planRemark?qdetail.planRemark:''}}</p> -->
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈结果</p>
						<p :title="qdetail1?qdetail1.result:''">{{qdetail1?qdetail1.result:''}}</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
						<p class="h-grayFont">交互图片</p>
						<ul>
							<li v-for="(item,index) in PhotoList" :key="index">
                <el-image
                    style="width: 0.6rem;height: 0.6rem;"
                    :src="item.saveurl"
                    :preview-src-list="srcList">
                </el-image>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-bBtn " :class="[qdetail1.cucode==nowcucode&&qdetail1.transform==0?'h-bgwhite':'h-bgblueQ2']" @click="dialogFormVisible6 = false">取消</el-button>
				<el-button v-if="qdetail1.cucode==nowcucode&&qdetail1.transform==0" class="h-btn h-formBtn h-bgblueQ2" @click="zhuanhuaxuqiu">一键转化需求</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible4" class="h-dialog2">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>选择需求类型</h1>
						<p>Choose Style</p>
					</div>
				</div>
			</div>
			<div class="h-formLines">
				<div class="xuqiuBoxList">
					<div class="xuqiulist" :class="{'active':xuqiudex==index}" v-for="(item,index) in xuqiuList" :key="index" @click="xuqiuGo(index)">
						<p>{{item}}</p>
						<img v-if="xuqiudex==index" src="../../assets/images/checkBox.png" style="margin-left:20px;" />
					</div>
				</div>
				<div class="xuqiutext" style="margin-top:30px;"><span style="color:#f46071">*</span>资源需求是指用户在使用海尔生物医疗产品中遇到了问题需要海尔生物医疗内部人员资源协助。由销售人员发起，对应的协助人员进行问题闭环处理。</div>
				<div class="xuqiutext"><span style="color:#f46071">*</span>信息获取是指销售人员在与客户沟通过程中收集到的产品购买意向，保留产品信息和预计购买金额。</div>
				<div style="display:flex;justify-content:center">
					<el-button class="h-btn h-formBtn h-bgblueQ2" @click="gotoxuqiu()">确定</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 吻合率弹框 -->
		<el-dialog :close-on-click-modal="false" title="跑动吻合率" :visible.sync="whldialogFlag" custom-class="body_dilog">
			<div class="h-rowIn">
				<div class="h-rowBox">
					<div class="h-rowCon" style="padding-top: 0;">
						<!-- <div class="h-formBox" style="margin-bottom: 1px;">
                            <div>{{nosum}}</div>
                            <div>{{nosoc}}</div>
                            <br>
                        </div> -->
						<div class="h-formBox" style="margin-bottom: 1px;">
							<el-form :inline="true" :model="q2" class="demo-form-inline h-formBorder">
								<el-form-item label="提报人">
									<el-input v-model="q2.cunameLike" placeholder="请输入提报人姓名" :clearable="true"></el-input>
								</el-form-item>
								<el-form-item label="时间">
									<el-col :span="11">
										<el-date-picker :clearable="false" @change="beginDate(q2)" v-model="q2.planTimeStart" value-format="yyyy-MM-dd"
										 type="date" placeholder="选择时间" style="width: 87%;"></el-date-picker>
									</el-col>
									<el-col :span="2">至</el-col>
									<el-col :span="11">
										<el-date-picker :clearable="false" @change="processDate(q2)" v-model="q2.planTimeEnd" value-format="yyyy-MM-dd"
										 type="date" placeholder="选择时间" style="width: 87%;"></el-date-picker>
									</el-col>
								</el-form-item>
								<el-form-item class="h-formBtnOut">
									<el-button class="h-btn h-formBtn h-bgblueQ" icon="el-icon-search" @click="pdwhllist">搜索</el-button>
								</el-form-item>
							</el-form>
						</div>
						<el-table size="mini" ref="multipleTable" :data="sumRank" tooltip-effect="dark" style="width: 100%" border>
							<el-table-column prop="userCode" label="账号">
							</el-table-column>
							<el-table-column prop="cuname" label="姓名">
							</el-table-column>
							<el-table-column prop="chartAll" label="计划数">
							</el-table-column>
							<el-table-column prop="chartDone" label="实际跑动数">
							</el-table-column>
							<el-table-column prop="adjScore" label="吻合率">
								<template slot-scope="scope">
									{{scope.row.chartAll?(scope.row.adjScore = new big(scope.row.chartDone|| 0).div(scope.row.chartAll).toFixed(2)*100 ):0}}%
								</template>
							</el-table-column>
						</el-table>
						<div class="h-tableB" style="display: flex;justify-content: space-between;align-items: center;">
								<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-edit" @click="exportExcelWhl">批量导出</el-button>
								<paginationmin :page="q2" @query="pdwhllist" />
						</div>
					</div>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import ss from '../../api/SystemService'
	import updownfile from '../../utils/updownfile'
	import uploadexcel from '../../components/uploaddown/uploadexcel'
	import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
	export default {
		components: {
			uploaddownexcel,
			uploadexcel
		},
		data() {
			return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				nowcucode:'',
				status: 1,
				showOrhide: false,
				checked: true,
				toshow: "guanhuai",
				daochu: false,
				value2: '',
				PhotoList: [],
        srcList:[],//交互图片预览集合
				//上传
				uploaddownexcelflag: false,
				//弹框-管理员跑动吻合率
				whldialogFlag: false,
				q2: {
					pageSize: 10,
					pageNo: 1,
					total: 0,
				},
				sumRank: [],
				blank1_1: false,
				blank1_2: false,
				blank2: false,
				care: {},
				jxDayData: "",
				jxDayValue: "",
				jxDayRank: "无",
				jxDayWidth: "0%",
				jxMonthData: "",
				jxMonthValue: "",
				jxMonthRank: "无",
				jxMonthWidth: "0%",
				paidex: 0,
				paiminglist: ['当天排名', '当月排名'],
				xuqiuList: ['资源需求', '信息获取'],
				xuqiudex: 0,
				//提报原因
				dialogFormVisible1: false,
				//修改计划
				dialogFormVisible2: false,
				//详情查看
				dialogFormVisible3: false,
				dialogFormVisible6: false,
				dialogFormVisible4: false,
				planBoxlist: false,
				planlists: [{
					active: 0,
					title: '青岛大学附属医院血液柜拜访',
					baifang: '常规拜访',
					time: '11:30~12:30',
				}],
				dialogFormVisible: false,
				formLabelAlign2: [{}],
				formLabelAlign3: {},
				rules2: {
					// formCon1: [
					// 	{ required: true, message: '', trigger: 'blur' },
					// ],
					euType: [{
						required: true,
						message: '请选择客户类型',
						trigger: 'blur'
					}, ],
					euCode: [{
						required: true,
						message: '请选择拜访客户',
						trigger: 'blur'
					}, ],
					planTimeStart: [{
						required: true,
						message: '请选择拜访时间',
						trigger: 'blur'
					}, ],
					planTimeEnd: [{
						required: true,
						message: '请选择拜访时间',
						trigger: 'blur'
					}, ],
					remark: [{
						required: true,
						message: '请输入过期原因',
						trigger: 'blur'
					}, ],
					// formCon9:[
					// 	{ required: true, message: '联系方式不能为空' ,trigger: 'blur' },
					// 	{ type: 'number', message: '联系方式必须为数字值', trigger: 'blur' }
					// ]
				},
				f: {
					userName: null,
				},
				EuName: [],
				qdetail: {},
				qdetail1: {},
				options1: [],
				options2: [],
				optionsCustomer: [],
				optionsAgent: [],
				optionsArea: [],
				tdate: new Date(),
				calenderValue: new Date(),
				yearOptions: [{
					value: '2017',
					label: '2017'
				}, {
					value: '2018',
					label: '2018'
				}, {
					value: '2019',
					label: '2019'
				}, {
					value: '2020',
					label: '2020'
				}],
				monthOptions: [{
					value: '1',
					label: '1月'
				}, {
					value: '2',
					label: '2月'
				}, {
					value: '3',
					label: '3月'
				}, {
					value: '4',
					label: '4月'
				}, {
					value: '5',
					label: '5月'
				}, {
					value: '6',
					label: '6月'
				}, {
					value: '7',
					label: '7月'
				}, {
					value: '8',
					label: '8月'
				}, {
					value: '9',
					label: '9月'
				}, {
					value: '10',
					label: '10月'
				}, {
					value: '11',
					label: '11月'
				}, {
					value: '12',
					label: '12月'
				}],
				yearValue: new Date().getFullYear() + "年",
				monthValue: new Date().getMonth() + 1 + "月",
				headnum: {
					plansum: 0,
					plandone: 0,
					planmatch: 0,
					grade: '',
					rqId: null
				},
				//表单
				q: {
					demandflag: false,
					cdateEnd: null,
					cdateBegin: null,
					pageSize: 8,
					pageNo: 1,
					total: 0,
				},
				//表单上面日历点击后页面
				q1: {
					pageSize: 4,
					pageNo: 1,
					total: 0,
				},
				//表格
				multipleSelection: [],
				tableData2: [],
				clickActive: 1,
				//日历
				calenderData: [],
				planList: [{}],
				detailDayString: "",
				executionId: null,
			}
		},
		methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
			timeSelect() {
				this.q.cdateBegin = this.value2[0];
				this.q.cdateEnd = this.value2[1];
			},
			getimgId(id) {
                this.PhotoList.push({
                    saveurl: this.$baseurl+'/api/file/fileopt/showImg?id='+id,
                })
        this.srcList.push(this.$baseurl+'/api/file/fileopt/showImg?id='+id);
				// ss.UserCare.imgDown(id).then(data => {
				// 	var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data + String.fromCharCode(
				// 		byte), ''))
				// 	if (imgbase) {
				// 		this.PhotoList.push({
				// 			saveurl: imgbase,
				// 		})
				// 	}
				// })
			},
			uploadExcelFilecallback(rd) {
				//this.$msg.alert(rd);
			},
			uploaddownexcelflagbtn() {
				this.uploaddownexcelflag = true;
			},
			tab2(index) {
				this.paidex = index;
				this.lineChart1(index);
			},
			//日历点击这个时间，日历点击那天的时间
			selecttime(times) {
				this.q1.pageNo = 1;
				this.selecttimeQ(times);
			},
			//翻页
			selecttimeQ(times) {
				// console.log(this.$util.riQi3(this.tdate))
				this.detailDayString = times;
				//交互计划详情\
				this.q1.planTimeEndEnd = times
				this.q1.planTimeStartBegin = times
				ss.UserCare.selectPage(this.q1).then(rd => {
					this.q1.total = rd.total;
					this.planlists = rd.records;
					if (this.planlists && this.planlists.length > 0) {
						this.planlists.forEach((item, index) => {
							if (item.planTimeEnd > this.$util.riQi3(this.tdate) && !item.executionId && (item.planStatus == 2 || item.planStatus ==
									6)) {
								//今天之前没有执行的计划
								item.active = 1;
							}
							if (item.planTimeEnd < this.$util.riQi3(this.tdate) && !item.executionId) {
								//今天之后没有执行的计划
								item.active = 2;
							}
							if (item.executionId) {
								item.active = 0;
							}
							if (this.$store.getters.hasRole("swyl_guanhgly")) {
								item.active = 9;
							}
						})
					}
				})
				this.planBoxlist = true;
			},
			customerType(v) {
				this.formLabelAlign3.euCode = null;
				this.formLabelAlign3.euName = null;
				this.formLabelAlign3.channelCode = null;
				this.formLabelAlign3.areaCode = null;
				this.formLabelAlign3.contactDept = null;
				this.formLabelAlign3.contact = null;
				this.formLabelAlign3.contactPhone = null;
				this.EuName = null;
			},
			//下拉框选中事件
			showForm(v) {
				let obj = {};
				obj = this.EuName.find((item) => { //这里的userList就是上面遍历的数据源
					return item.userName === v; //筛选出匹配数据
				});
				this.formLabelAlign3.euCode = obj.userCode; //我这边的name就是对应label的
				this.formLabelAlign3.contactDept = obj.department ? obj.department : '';
				this.formLabelAlign3.contact = obj.contactuserName ? obj.contactuserName : '';
				this.formLabelAlign3.contactPhone = obj.telephone ? obj.telephone : '';
			},
			gundong() {
				document.documentElement.scrollTop = 840;
			},
			//通过用户名带出详细信息
			showFormList(value) {
				this.f.userName = value;
				if (this.formLabelAlign3.euType == 1) {
					ss.UserCare.agentOption(this.f).then(rd => {
						this.EuName = rd;
					})
				} else if (this.formLabelAlign3.euType == 2) {
					ss.UserCare.customerOption(this.f).then(rd => {
						this.EuName = rd;
					})
				}
			},
			tibaobut(item) {
				this.dialogFormVisible1 = true;
				ss.UserCare.planDetail({
					id: item
				}).then(rd => {
					this.formLabelAlign3 = rd.plan;
				})
			},
			editorplan(item) {
				this.dialogFormVisible2 = true;
				ss.UserCare.planDetail({
					id: item
				}).then(rd => {
					this.formLabelAlign3 = rd.plan;
				})
			},
			handleSizeChange() {},
			handleCurrentChange() {},
			//表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			headerClick() {},
			//切换列表
			handleTabClick(a) {
				if (a == this.clickActive) {
					return
				} else {
					this.clickActive = a
				}
			},
			//我的日程年的切换
			handleYearClick() {
				this.calenderValue = (this.yearValue + "-" + this.monthValue).split("月")[0]
				this.queryAgenda();
			},
			//我的日程月的切换
			handleMonthClick() {
				this.calenderValue = this.yearValue.split("年")[0] + "-" + this.monthValue
				this.queryAgenda();
			},
			handleDateClick(a) {
				this.yearValue = a.getFullYear() + "年";
				this.monthValue = a.getMonth() + 1 + "月"
			},
			lineChart() {
				let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
				let option = {
					grid: {
						top: "20px",
						left: "0px",
						right: "10px",
						bottom: "40px"
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							show: true,
							lineStyle: {
								color: '#61a0f7'
							}
						}
					},
					legend: {
						show: false
					},
					calculable: true,
					xAxis: [{
						type: 'category',
						data: [],
						axisLine: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							color: '#b9b9b9',
							fontFamily: 'Microsoft YaHei',
							fontSize: 18
						}
					}],
					yAxis: [{
						type: 'value',
						axisLine: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: false
						}
					}],
					series: [{
						name: '跑动排名',
						type: 'line',
						symbol: 'circle',
						symbolSize: 0,
						showSymbol: false,
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: 'rgba(145,188,250,1)' // 0% 处的颜色
								}, {
									offset: 0.5,
									color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(145,188,250,0)' // 100% 处的颜色
								}],
								globalCoord: false // 缺省为 false
							},
						},
						smooth: true,
						data: [],
						lineStyle: {
							color: '#61a0f7'
						},
						itemStyle: {
							normal: {
								color: '#ffffff',
								borderColor: '#61a0f7',
								borderWidth: 2
							}
						}
					}]
				};
				lineChart.setOption(option);
			},
			lineChart1(index) {
				var jxDayRank = this.jxDayRank;
				var jxMonthRank = this.jxMonthRank;
				let lineChart1 = this.$echarts.init(document.getElementById('h_barChart'));
				var dataAxis = [];
				var data = [];
				var dataShadow = [];
				let option = {
					grid: {
						top: "20px",
						left: "10px",
						right: "10px",
						bottom: "40px"
					},
					xAxis: {
						show: false,
						data: dataAxis,
						axisLabel: {
							inside: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						z: 10
					},
					yAxis: {
						show: false,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#999'
							}
						}
					},
					dataZoom: [{
						type: 'inside'
					}],
					series: [{ // For shadow
							type: 'bar',
							barWidth: "5%",
							barGap: "10%",
							itemStyle: {
								normal: {
									color: 'rgba(0,0,0,0.05)',
									barBorderRadius: 5,
								}
							},
							barGap: '-100%',
							barCategoryGap: '40%',
							data: dataShadow,
							animation: false
						},
						{
							type: 'bar',
							itemStyle: {
								normal: {
									// color: '#61a8fd',
									color: function(params) {
										if ((index == 0 && params.dataIndex + 1 == jxDayRank) || (index == 1 && params.dataIndex + 1 ==
												jxMonthRank)) {
											return '#F4A82D';
										} else {
											return '#61a8fd';
										}
									},
									barBorderRadius: 5,
								}
							},
							data: data
						}
					]
				};
				lineChart1.setOption(option);
				if (index == 0) {
					lineChart1.setOption({
						xAxis: {
							data: this.jxDayData
						},
						series: [{
								name: 'shadow',
								data: this.jxDayValue
							},
							{
								name: 'bar',
								data: this.jxDayValue
							}
						]
					})
				} else {
					lineChart1.setOption({
						xAxis: {
							data: this.jxMonthData
						},
						series: [{
								name: 'shadow',
								data: this.jxMonthValue
							},
							{
								name: 'bar',
								data: this.jxMonthValue
							}
						]
					})
				}
			},
			query() {
				console.log(this._user.usercode,"11111111111111111")
				this.daochu = this.$store.getters.hasRole("swyl_admin,swyl_guanhgly");
				ss.UserCare.allexec(this.q).then(rd => {
				  let _this = this;
					this.q.total = rd.total;
					this.tableData2 = rd.records;
					this.tableData2.forEach((elememts,index) => {
						if (elememts.carePhoto && elememts.carePhoto.length > 0) {
                            elememts.saveurl = this.$baseurl+'/api/file/fileopt/showImg?id='+elememts.carePhoto[0].id;
                            _this.srcList.push(_this.$baseurl+'/api/file/fileopt/showImg?id='+elememts.carePhoto[index].id)
							// ss.UserCare.imgDown(elememts.carePhoto[0].id).then(data => {
							// 	var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data +
							// 		String.fromCharCode(
							// 			byte), ''));
							// 	if (imgbase != 'data:image/png;base64') {
							//
							// 	}
							// })

						}

					});
				})
			},
			pdwhllist() {
				//跑动吻合率列表
				ss.UserCare.whlPage(this.q2).then(rd => {
					//查询这一天的用户人数，审核情况等
					this.whldialogFlag = true;
					console.log("跑动吻合率列表===", rd);
					this.sumRank = rd.records;
					this.q2.total = rd.total;

				})
			},
			queryAgenda() {
				ss.UserCare.allplan({
					year: this.yearValue.split("年")[0],
					month: this.monthValue.split("月")[0]
				}).then(rd => {
					this.calenderData = rd.plans;
				})
			},
			handleFilter() {
				this.query();
			},
			checkDetail(item) {
				//查看详情
				this.dialogFormVisible3 = true
				ss.UserCare.planDetail({
					id: item
				}).then(rd => {
					this.qdetail = rd.plan;
					console.log(this.qdetail,"11111111111111111111")
					this.PhotoList = [];
					if (rd.plan.userCareExecution.carePhoto) {
						for (var i = 0; i < rd.plan.userCareExecution.carePhoto.length; i++) {
							this.getimgId(rd.plan.userCareExecution.carePhoto[i].id)
						}
					}
				})
			},
			saveJingPin(value) {
				this.$router.push({
					path: "/presentation1",
					query: {
						id: value
					}
				});
			},
			checkDetail2(item) {
				//下面列表的查看详情
				this.dialogFormVisible6 = true;
				this.executionId = item;
				ss.UserCare.planDetail2({
					executionId: item
				}).then(rd => {
					this.qdetail1 = rd.plan.userCareExecution;
					console.log(this.qdetail1,"222222222222222")
					this.PhotoList = [];
					if (rd.plan.userCareExecution.carePhoto) {
						for (var i = 0; i < rd.plan.userCareExecution.carePhoto.length; i++) {
							this.getimgId(rd.plan.userCareExecution.carePhoto[i].id)
						}
					}
				})
			},
			//批量删除
			deleteExe() {
				var idlist = [];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.$msg.confirm("确认删除?", () => {
					ss.UserCare.deleteExe(idlist).then(rd => {
						this.$msg.msgs(rd.msg);
						this.query();
					});
				});
			},
			//明细导出
			exportExcel() {
				var idlist = [];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.q.ids = idlist
				updownfile.down("/api/swyl/v1/guanhuai/userCareExecution/downloadExcel", this.q, "post", 'data');
			},
			//明细导出
			exportExcelWhl() {
				updownfile.down("/api/swyl/v1/guanhuai/userCarePlan/downloadExcelWhl", this.q2, "post", 'data');
			},
			//导入
			beforeUpload(file) {
				updownfile.uploadExcel("/api/swyl/v1/guanhuai/userCareExcel/uploadExcel", file).then(rd => {}).catch(error => {
					return Promise.reject(error);
				})
				return false;
			},
			addplanList() {
				var a = {}
				this.planList.push(a)
			},
			delplanList() {
				this.planList.splice(0, 1)
			},
			addplan() {
				this.dialogFormVisible = true;
			},
			addweek() {
				//创建周计划，查询当前用户下周计划状态
				var planstatus = 0;
				ss.UserCare.weekPlanStatus().then(rd => {
					if (rd.obj && rd.obj.length > 0) {
						planstatus = rd.obj[0].planStatus;
						if (planstatus == 1) {
							this.$msg.msge("周计划已提交，请等待审核");
						} else if (planstatus == 2) {
							this.$msg.msge("周计划已生成，请勿重复操作");
							// this.$message({
							// 	message: '周计划已生成，请勿重复操作',
							// 	type: 'warning'
							// });
						} else {
							this.$router.push("/weekplan");
						}
					} else {
						this.$router.push("/weekplan");
					}
				})
			},
			gotoxuqiu() {
				console.log(this.xuqiudex)
				if (this.xuqiudex == 0) {
					this.$router.push({
						path: '/transforming_demand2',
						query: {
							id: this.executionId
						}
					})
					this.dialogFormVisible1 = false;
				} else if (this.xuqiudex == 1) {
					this.$router.push({
						path: '/transforming_demand1',
						query: {
							id: this.executionId
						}
					})
					this.dialogFormVisible1 = false;
				}
			},
			zhuanhuaxuqiu() {
				this.dialogFormVisible4 = true;
			},
			xuqiuGo(index) {
				this.xuqiudex = index;
			},
			reset() {
				this.q = {
					pageSize: this.q.pageSize,
					pageNo: this.q.pageNo,
					total: this.q.total
				}
			},
			submitReasonOrChange(v) {
				//过期未执行提报原因
				let msg = "确认修改计划？";
				var subflag = true;
				if (v == 1) {
					msg = "确认提报原因？";
					if (!this.formLabelAlign3.remark) {
						this.$msg.msge("请填写提报原因");
						this.$refs['formLabelAlign3'].validate((valid) => {
							return valid;
						})
						subflag = false;
					}
					this.formLabelAlign3.planStatus = 4; //提交
				} else {
					//修改计划
					this.formLabelAlign3.planStatus = 2; //提交
				}
				if (subflag) {
					this.$msg.confirm(msg, () => {
						ss.UserCare.updateById(this.formLabelAlign3).then(rd => {
							this.$msg.msgs("提交成功");
							this.dialogFormVisible1 = false;
							this.dialogFormVisible2 = false;
						})
					})
				}
			},
			getHead() {
				ss.UserCare.headline({}).then(rd => {
					if (rd.f) {
						this.headnum.headnum = rd.planHead.sum;
						this.headnum.headdone = rd.planHead.done;
						this.headnum.headmatch = rd.planHead.match;
						this.headnum.grade = rd.planHead.grade;
						this.headnum.rqId = rd.planHead.rqId;
					}
					console.log("头部的值", this.headnum);
				})
			},
			//时间限制
			beginDate(v) {
				if (v.planTimeEnd) { //如果结束时间不为空，则小于结束时间
					if (v.planTimeEnd < v.planTimeStart) {
						this.$msg.msge("结束日期不能小于开始日期");
						v.planTimeStart = "";
					}
				}
			},
			processDate(v) {
				if (v.planTimeStart) { //如果有出厂日期
					//如果购买日期小于出厂日期
					if (v.planTimeEnd < v.planTimeStart) {
						this.$msg.msge("结束日期不能小于开始日期");
						v.planTimeEnd = "";
					}
				}
			},
			// 关闭新手引导页
			closeIt() {
				this.showOrhide = false;
				if (this.checked) {
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			},
			nextStep(i) {
				if (this.status == 1) {
						this.status = 2;
				} else if (this.status == 2) {
						this.status = 3;
				} else if (this.status == 3) {
						this.status = 4;
				} else if (this.status == 4) {
						this.status = 5;
				} else if (this.status == 5) {
						this.status = 6;
						document.documentElement.scrollTop = 180;
				} else if (this.status == 6) {
						this.status = 7;
						document.documentElement.scrollTop = 480;
				} else if (this.status == 7) {
						this.status = 8;
				} else if (this.status == 8) {
						this.status = 9;
						document.documentElement.scrollTop = 1200;
				} else if (this.status == 9) {
					if (this.checked) {
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					} else {
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},

		},
		mounted() {

			this.lineChart();
			this.lineChart1();
			this.query();
			//跑动排行
			ss.firstPageService.getUserCareRanking().then(rd => {
				var careData = [];
				var careValue = [];
				if (rd.careList != null && rd.careList.length > 0) {
					for (var i = 0; i < rd.careList.length; i++) {
						var cl = rd.careList[i];
						careData.push(cl.orderDate);
						careValue.push(cl.orderNo);
					}
					this.care = rd.care;
					let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
					lineChart.setOption({
						xAxis: [{
							type: 'category',
							data: careData
						}],
						series: [{
							type: 'line',
							data: careValue
						}]
					})
				} else {
					this.blank2 = true;
				}
			});
			//绩效排行,当天
			ss.firstPageService.getJiXiaoRanking({
				type: 'day'
			}).then(rd => {
				var cuser = rd.cuser;
				var jxData = [];
				var jxValue = [];
				if (rd.list != null && rd.list.length > 0) {
					for (var i = 0; i < rd.list.length; i++) {
						var cl = rd.list[i];
						jxData.push(cl.cuname);
						jxValue.push(cl.proTotalAmount);
						if (cuser == cl.cuname) {
							this.jxDayRank = parseInt(cl.id);
							this.jxDayWidth = (rd.list.length - cl.id + 1) * 100 / rd.list.length + '%';
						}
					}
					this.jxDayData = jxData;
					this.jxDayValue = jxValue;
					this.lineChart1(0);
				} else {
					this.blank1_1 = true;
				}
			});
			//绩效排行,当月
			ss.firstPageService.getJiXiaoRanking({
				type: 'month'
			}).then(rd => {
				var cuser = rd.cuser;
				var jxData = [];
				var jxValue = [];
				if (rd.list != null && rd.list.length > 0) {
					for (var i = 0; i < rd.list.length; i++) {
						var cl = rd.list[i];
						jxData.push(cl.cuname);
						jxValue.push(cl.proTotalAmount);
						if (cuser == cl.cuname) {
							this.jxMonthRank = parseInt(cl.id);
							this.jxMonthWidth = (rd.list.length - cl.id + 1) * 100 / rd.list.length + '%';
						}
					}
					this.jxMonthData = jxData;
					this.jxMonthValue = jxValue;
				} else {
					this.blank1_2 = true;
				}
			});

		},
		created() {
			this.showzhezhao()
			this.queryAgenda();
			this.getHead();
			this.options2 = this.$store.getters.dicts["userCareType"];
			this.nowcucode = this._user.usercode;
		}
	}
</script>

<style scoped>
	.h-dialogForm .h-elformWrap-1 {
		margin-bottom: 0.2rem;
	}

	.textBox {
		margin-left: 20px;
		margin-top: -10px;
	}

	.textBox span {
		color: #bec3c4;
		font-size: 16px;
		margin-left: 30px;
	}

	.textBox span:first-child {
		margin: 0;
	}

	.selecBox {
		display: flex;
	}

	.selecBox .button {
		width: 85px;
		height: 32px;
		color: #767676;
		text-align: center;
		line-height: 28px;
		border: 1px solid #dddfe4;
		background: #fff;
		cursor: pointer;
		font-size: 0.16rem;
	}

	.selecBox .button.active {
		background: #2686e7;
		color: #fff;
		border-color: #2686e7;
	}

	.paimingBox {
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		margin-left: 10px;
	}

	.paimingBox .title {
		font-size: 14px;
		color: #c6ced1;
		margin-bottom: 10px;
	}

	.paimingBox .borderBox {
		height: 12px;
		border-radius: 6px;
		background: #def2ff;
		position: relative;
	}

	.paimingBox .borderBox .borders {
		position: absolute;
		width: 20%;
		height: 12px;
		border-radius: 6px;
		background: #5aabff;
	}

	.planList {
		margin-top: 40px;
	}

	.planList:first-child {
		margin-top: 0
	}

	.planBoxzhezhao {
		width: 100%;
		height: 7.2rem;
		background: rgba(0, 0, 0, 0.3);
		position: absolute;
		top: 10px;
		left: 0;
		box-sizing: border-box;
	}

	.planBoxs {
		width: 90%;
		height: 90%;
		background: #fff;
		border: 1px solid #c4c4c4;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		padding: 40px 40px 20px 40px;
		box-sizing: border-box;
	}

	.planBoxs .planBoxtop {
		font-size: 18px;
		color: #282828;
	}

	.planBoxs .planBoxcenter {
		margin-top: 10px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 60px;
		border-bottom: 1px solid #eee;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .divs {
		width: 16.666%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .yellowtext {
		width: 61px;
		height: 29px;
		background-color: #fbdfc8;
		border-radius: 15px;
		font-size: 14px;
		color: #ee9433;
		text-align: center;
		line-height: 29px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .centertext {
		font-size: 14px;
		color: #323232;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .baifantext {
		font-size: 14px;
		color: #a7a7a7;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .timetext {
		font-size: 14px;
		color: #a7a7a7;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .nullwan {
		width: 74px;
		height: 29px;
		border-radius: 15px;
		border: solid 1px #ee9433;
		font-size: 14px;
		color: #ee9433;
		text-align: center;
		line-height: 29px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .editortext {
		width: 67px;
		height: 29px;
		background-color: #3e99f2;
		border-radius: 15px;
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 29px;
		cursor: pointer;
		margin-left: 15px;
	}

	.planBoxs .planBoxcenter .planBoxcenterlist .chakan {
		font-size: 14px;
		color: #3e99f2;
		text-align: center;
		cursor: pointer;
	}

	.planBoxs .planBoxbottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.backtext {
		width: 80px;
		height: 26px;
		background-color: #3e99f2;
		border-radius: 5px;
		text-align: center;
		line-height: 26px;
		color: #fff;
		font-size: 14px;
		cursor: pointer;
		margin-top: 0.2rem;
	}

	.h-calendarSelect .h-selectLine {
		display: inline-block;
		vertical-align: middle;
		margin-left: 0.30rem;
		margin-right: 0.12rem;
		font-size: 0.22rem;
		color: #2381e8;
	}

	.yxgundong {
		height: 234px;
		overflow-y: auto;
	}

	.yxgundong::-webkit-scrollbar {
		display: none;
	}

	.h-formLines {
		padding: 30px 48px;
	}

	.xuqiuBoxList {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}

	.xuqiuBoxList .xuqiulist {
		width: 215px;
		height: 62px;
		border-radius: 4px;
		background: #fff;
		border: 1px solid #959595;
		text-align: center;
		line-height: 62px;
		color: #989898;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.xuqiuBoxList .xuqiulist.active {
		background: #238cfd;
		border: 1px solid #238cfd;
		color: #fff;
	}
</style>
<style>
	.guanhuaibox .el-image , .guanhuaibox .el-image-viewer__wrapper{
		z-index: 9999999999!important;
	}
	.h-calenderSign span:last-child {
		margin-right: 0
	}

	.h-dialog .el-dialog__headerbtn .el-dialog__close {
		height: 0.42rem;
		width: 0.42rem;
		line-height: 0.42rem;
		font-size: 0.34rem;
	}

	.fenyes .h-pagiLabel {
		display: none;
	}

	.fenyes .el-pagination .el-pagination__sizes {
		display: none;
	}

	.h-formReason .h-formbLine .el-textarea .el-textarea__inner {
		height: 23px !important;
		min-height: none;
	}

	.timeselect .el-date-editor .el-range-separator {
		width: 10%;
		line-height: 0.35rem;
	}

	.h-formBorder .timeselect .el-input__inner {
		padding-right: 0.1rem;
	}

	/* .h-formBorder .timeselect .el-form-item__content {
		line-height: 0.2rem;
	} */

	.h-formBorder .timeselect .el-date-editor .el-range-separator {
		width: 8%;
		line-height: 0.35rem;
	}
	.ljjcalendar .el-calendar-table .el-calendar-day{
		height: 1.08rem;
		padding: 0.06rem;
	}
</style>
<style scoped lang="scss">
	.bottomTip {
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}

	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}

	.leaderBox {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;

		.leaderbg {
			width: 100%;
			height: 100%;
		}

		.steps {
			position: absolute;
			z-index: 1;
		}

		.step1 {
			top: 0.8rem;
			left: 0rem;
			width: 5.65rem;
			height: 20rem;
		}

		.step2 {
			top: 1.5rem;
			left: 5.3rem;
			width: 3.5rem;
			height: 2.53rem;
		}

		.step3 {
			top: 1.5rem;
			right: 2.7rem;
			width: 3rem;
			height: 2.53rem;
		}

		.step4 {
			top: 1.5rem;
			right: 0rem;
			width: 3rem;
			height: 2.53rem;
		}

		.step5 {
			top: 2rem;
			right: 7.1rem;
			width: 2rem;
			height: 1.5rem;
		}

		.step6 {
			top: 2rem;
			left: 2.8rem;
			width: 14.5rem;
			height: 7rem;
		}

		.step7 {
			top: 6.9rem;
			left: 2.95rem;
			width: 9rem;
			height: 2rem;
		}

		.step8 {
			top: 6.15rem;
			left: 15.7rem;
			width: 2rem;
			height: 1.4rem;
		}

		.step9 {
			top: 7.55rem;
			left: 2.7rem;
			width: 1.62rem;
			height: 1.7rem;
		}

		.stepbtn {
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}

		.closeIt {
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
